import React from "react";
import { useHistory } from "react-router-dom";
import posthog from "posthog-js";
import { PORTAL_BASE_URL, REGISTER_POSTHOG_API_KEY, POSTHOG_API_HOST } from "../../../env";
import "./CtaSection.scss";

const CtaSection = () => {
    const history = useHistory();

    const handleStartFree = () => {
        const urlParams  = new URLSearchParams(window.location.search);
        const email      = urlParams.get("email") || "";
        let utm_source   = localStorage.getItem("utm_source") || urlParams.get("utm_source");

        const ph = posthog.init(REGISTER_POSTHOG_API_KEY, {
            api_host: POSTHOG_API_HOST,
            autocapture: false,
            name: "register",
            capture_pageview: false,
            disable_session_recording: true,
            loaded: (ph) => {
                if (utm_source) ph.register({ utm_source: utm_source });
            },
        });
        if (!utm_source) utm_source = "direct";
        if (ph) {
            ph.capture("free_trial_click", {
                location: window.location.pathname,
                button:   "try_ai_images_for_free",
                utm_source,
                email,
            });
        }

        const redirectPath = `/select-subscription?plan=free_trial_ai&plan_type=smb_3d_services&utm_source=${utm_source}`;
        window.location.href = `${PORTAL_BASE_URL}/register?redirectURL=${encodeURIComponent(redirectPath)}`;
    };

    return (
        <div className="lv2-cta-wrapper">
            <div className="lv2-cta-glow" />

            <h2 className="manrope f-50 w-600 lh-60 white lv2-cta-heading">
                Get started today with ALL3D
            </h2>

            <div className="lv2-cta-btns">
                <button
                    className="btn gradient-button manrope f-16 w-500 lh-24 white"
                    onClick={handleStartFree}
                >
                    Start for free now
                </button>
                <button
                    className="lv2-cta-btn-dark manrope f-16 w-500 lh-24 white"
                    onClick={() => history.push("/pricing")}
                >
                    View plans &amp; pricing
                </button>
            </div>
        </div>
    );
};

export default CtaSection;
